import {
  useShowContext,
  Labeled,
  FunctionField,
  useGetOne,
  useList,
  ListContextProvider,
  Datagrid,
  TextField,
} from "react-admin";
import { Box, Rating } from "@mui/material";

const metaRatings = {
  sparseFields: [
    "id",
    "rating",
    {
      ratings: ["id", "clientId", "providerId", "createdTimestamp", "rating"],
    },
  ],
};

const metaReviews = {
  sparseFields: [
    "id",
    {
      reviews: [
        "id",
        "clientId",
        "clientUserName",
        "createdTimestamp",
        "providerId",
        "review",
      ],
    },
  ],
};

const OtherReviewsField = () => {
  const { record, resource } = useShowContext();
  const id = record.id;

  const {
    data: providerRatings,
    isLoading: isGetOneLoadingRatings,
    error: errorRatings,
  } = useGetOne(resource, { id, meta: metaRatings });

  const {
    data: providerReviews,
    isLoading: isGetOneLoadingReviews,
    error: errorReviews,
  } = useGetOne(resource, { id, meta: metaReviews });

  const getReviewForRating = (clientId) => {
    const review = providerReviews.reviews?.find(
      (r) => r.clientId === clientId,
    );
    return review?.review ?? "-";
  };

  const otherReviewsListContext = useList({
    data: (providerReviews ? providerReviews.reviews : []).filter(
      (item) =>
        !(providerRatings?.ratings || [])
          .map((r) => r.clientId)
          .includes(item.clientId) &&
        !(record?.references || []).map((r) => r.id).includes(item.clientId),
    ),
    resource: "Review",
  });

  if (isGetOneLoadingRatings || isGetOneLoadingReviews) {
    return <div>Loading...</div>;
  }

  if (errorRatings) {
    throw errorRatings;
  }

  if (errorReviews) {
    throw errorReviews;
  }

  if (otherReviewsListContext.data.length === 0) {
    return null;
  }

  return (
    <Labeled sx={{ width: "100%" }} label="No reference or rating reviews">
      <ListContextProvider value={otherReviewsListContext}>
        <Datagrid
          bulkActionButtons={false}
          sx={{ "& thead": { display: "none" } }}
          rowSx={(_, index) => ({
            td: { padding: index > 0 ? "8px 0" : "0 0 8px" },
          })}
          rowClick={false}
        >
          <Box
            sx={{
              display: "grid",
              gap: "8px 32px",
              gridTemplateColumns: "auto auto 1fr auto",
            }}
          >
            <Labeled label="Customer Name">
              <TextField source="clientUserName" />
            </Labeled>

            <Labeled label="Added on">
              <FunctionField
                render={(value) =>
                  value["createdTimestamp"]
                    ? new Date(+value["createdTimestamp"]).toDateString()
                    : "-"
                }
              />
            </Labeled>

            <Labeled
              label="Review"
              component="div"
              sx={{ gridColumn: "span 3" }}
            >
              <FunctionField
                source="reviews.review"
                render={(value) => getReviewForRating(value.clientId)}
              />
            </Labeled>
          </Box>
        </Datagrid>
      </ListContextProvider>
    </Labeled>
  );
};

export default OtherReviewsField;
